import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Folder } from 'src/app/interfaces/folder';
import { FolderService } from 'src/app/services/api/folder.service';

@Component({
    selector: 'app-folder-edit',
    templateUrl: './folder-edit.component.html',
    styleUrls: ['./folder-edit.component.scss']
})
export class FolderEditComponent implements OnInit {

    @Input() folder!: Folder;

    public errorMessage: string = '';
    public errorType: string = '';
    
    public folderForm: FormGroup | undefined;

    constructor(public activeModal: NgbActiveModal,
                private folderService: FolderService) { }

    ngOnInit(): void {
        this.createForm();
    }

    private createForm() {
        this.folderForm = new FormGroup({
            name: new FormControl(this.folder?.title, [Validators.required])
        });
    }

    updateFolder(folderFormValue : any) {
        if (folderFormValue != "" && folderFormValue.name != this.folder.title) {
            // Appel API pour changer le nom du dossier (id + nouveau nom)
            this.folderService.updateFolderName(this.folder.id, folderFormValue.name).subscribe((res) => {
                if (res.result == 'SUCCESS') {
                    this.activeModal.close(folderFormValue.name);
                } else {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            });
        } else {
            this.errorMessage = "ERRORS.FOLDERS.NO-NAME-SAME-NAME";
            this.errorType = "ERROR";
        }
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.folderForm?.controls[controlName].hasError(errorName);
    }


}
